<template>
  <div class="input">
    <div class="input-label">アプリタイトル</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="title">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    title: {
      get: function () {
        return this.$store.state.app.title
      },
      set: function (value) {
        this.$store.commit('app/setTitle', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
